import React, { Component } from 'react';
import { ColorsDM } from '../datamodel/datamodel';


class IteamChooseColorMenuComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentcolor: ColorsDM.navy
        };

        this.chooseColorMenu = React.createRef();
    }

    componentDidMount() {
        let componentHeight = this.chooseColorMenu.current.offsetHeight;
        let chooseColorBtnTop = this.props.chooseColorBtnTop;
        let chooseColorBtnHeight = this.props.chooseColorBtnHeight;
        let componentTop = Math.round(chooseColorBtnTop - componentHeight / 2 + chooseColorBtnHeight / 2);
        this.chooseColorMenu.current.style.top = `${componentTop}px`;

        console.log('COLORS MENU CALLING DISABLE GAME INPUTS');
        this.props.disableGameInputsCallback();
    }
    
    componentWillUnmount(){
        console.log('COLORS MENU CALLING ENABLE GAME INPUTS');
        this.props.enableGameInputsCallback();
    }

    chooseColorItemClickHandler(color) {
        this.setState({currentcolor: color});
        this.props.setCurrentColor(color);
        this.props.showChooseColorMenu();
    }

    render() {
        return (<div className='iteamColorChooseMenu' ref={this.chooseColorMenu}>
            <div className='iteamColorChooseMenuBlend'></div>
            <div className='iteamColorChooseMenuRow'>
                <div className='iteamColorChooseMenuCol'>
                    <button className='iteamColorChooseMenuButton colorBlack'
                        onPointerDown={event => event.stopPropagation()}
                        onPointerUp={event => event.stopPropagation()}
                        onClick={event => {event.stopPropagation(); this.chooseColorItemClickHandler(ColorsDM.black)}}></button>
                </div>
                <div className='iteamColorChooseMenuCol'>
                    <button className='iteamColorChooseMenuButton colorWhite'
                        onPointerDown={event => event.stopPropagation()}
                        onPointerUp={event => event.stopPropagation()}                    
                        onClick={event => {event.stopPropagation(); this.chooseColorItemClickHandler(ColorsDM.white)}}></button>
                </div>
                <div className='iteamColorChooseMenuCol'>
                    <button className='iteamColorChooseMenuButton colorGrey'
                        onPointerDown={event => event.stopPropagation()}
                        onPointerUp={event => event.stopPropagation()}                    
                        onClick={event => {event.stopPropagation(); this.chooseColorItemClickHandler(ColorsDM.grey)}}></button>
                </div>
                <div className='iteamColorChooseMenuCol'>
                    <button className='iteamColorChooseMenuButton colorNavy'
                        onPointerDown={event => event.stopPropagation()}
                        onPointerUp={event => event.stopPropagation()}                    
                        onClick={event => {event.stopPropagation(); this.chooseColorItemClickHandler(ColorsDM.navy)}}></button>
                </div>
                <div className='iteamColorChooseMenuCol'>
                    <button className='iteamColorChooseMenuButton colorBrown'
                        onPointerDown={event => event.stopPropagation()}
                        onPointerUp={event => event.stopPropagation()}                    
                        onClick={event => {event.stopPropagation(); this.chooseColorItemClickHandler(ColorsDM.brown)}}></button>
                </div>
                <div className='iteamColorChooseMenuCol'>
                    <button className='iteamColorChooseMenuButton colorGreen'
                        onPointerDown={event => event.stopPropagation()}
                        onPointerUp={event => event.stopPropagation()}                    
                        onClick={event => {event.stopPropagation(); this.chooseColorItemClickHandler(ColorsDM.green)}}></button>
                </div>
            </div>
            <div className='iteamColorChooseMenuRow'>
                <div className='iteamColorChooseMenuCol'>
                    <button className='iteamColorChooseMenuButton colorBlue'
                        onClick={() => {this.chooseColorItemClickHandler(ColorsDM.blue)}}></button>
                </div>
                <div className='iteamColorChooseMenuCol'>
                    <button className='iteamColorChooseMenuButton colorPurple'
                        onClick={() => {this.chooseColorItemClickHandler(ColorsDM.purple)}}></button>
                </div>
                <div className='iteamColorChooseMenuCol'>
                    <button className='iteamColorChooseMenuButton colorPink'
                        onClick={() => {this.chooseColorItemClickHandler(ColorsDM.pink)}}></button>
                </div>
                <div className='iteamColorChooseMenuCol'>
                    <button className='iteamColorChooseMenuButton colorYellow'
                        onClick={() => {this.chooseColorItemClickHandler(ColorsDM.yellow)}}></button>
                </div>
                <div className='iteamColorChooseMenuCol'>
                    <button className='iteamColorChooseMenuButton colorOrange'
                        onClick={() => {this.chooseColorItemClickHandler(ColorsDM.orange)}}></button>
                </div>
                <div className='iteamColorChooseMenuCol'>
                    <button className='iteamColorChooseMenuButton colorRed'
                        onClick={() => {this.chooseColorItemClickHandler(ColorsDM.red)}}></button>
                </div>
            </div>
        </div>);
    }
}

export default IteamChooseColorMenuComponent;